/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { fieldList as i } from "./fieldList.mjs";
const s = {};
s.undefined = (t) => t;
const f = (t, e) => e && e.arrays && !isNaN(Number(t)) ? [] : {};
function d(t) {
  if (s[t])
    return s[t];
  const e = i(t);
  return s[t] = (u, c, a) => {
    let r = u;
    const o = e.length - 1;
    for (let n = 0; n < o && r; n++)
      r = r[e[n]] = r[e[n]] || f(e[n + 1], a);
    r[e[o]] = c;
  }, s[t];
}
export {
  d as setter
};
